/**
 * @file
 * Theme javascript.
 */
// eslint-disable-next-line func-names
(function () {
  // Enregistre un objet (nom, valeur, temps d'expiration (en ms)) dans le cache du navigateur
  window.setWithExpiry = function setWithExpiry(key, value, ttl) {
    const now = new Date();

    // `item` est un objet qui contient la valeur de l'element enregistré et le temps au bout duquel il est supposé expirer
    const item = {
      value,
      expiry: now.getTime() + ttl,
    };
    window.localStorage.setItem(key, JSON.stringify(item));
  };

  window.getWithExpiry = function getWithExpiry(key) {
    const itemStr = window.localStorage.getItem(key);

    // Si l'item n'existe pas, retourner null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();

    // Compare le delai d'expiration de l'item avec le temps actuel
    if (now.getTime() > item.expiry) {
      // Si l'item a expiré, on le supprime du cache
      // et retourne null
      window.localStorage.removeItem(key);
      return null;
    }
    return item.value;
  };

  // Action liée au bouton 'Continuer sans accepter' des cookies.
  // Après clic, le panneau reapparaitra au bout d'un temps défini en milisecondes (ici 30 minutes)
  window.continueWithoutAccepting = function continueWithoutAccepting(
    clicked = false,
  ) {
    if (clicked) {
      window.setWithExpiry("continueWithoutAccepting", "1", 1000 * 60 * 30);
    }
    if (typeof Storage === "undefined") {
      return;
    }

    const alertBig = document.querySelector(
      "body #tarteaucitronRoot #tarteaucitronAlertBig",
    );

    if (window.getWithExpiry("continueWithoutAccepting") === "1") {
      if (alertBig) {
        alertBig.style.zIndex = "-1";
        alertBig.style.display = "none";
        alertBig.style.visibility = "hidden";
      }
      return;
    }

    if (window.tarteaucitron === undefined) {
      return;
    }

    let display = false;
    const cookieValue = tarteaucitron.cookie.read();
    if (cookieValue) {
      const [, value] = cookieValue.split("=");
      if (value === "wait") {
        display = true;
      }
    }

    if (display && alertBig) {
      alertBig.style.zIndex = "10000";
      alertBig.style.display = "block";
      alertBig.style.visibility = "visible";
    }
  };

  // Liens externes flaggués comme externe par un attribut rel (ou pointant
  // vers un .pdf) : s'ouvrent dans une nouvelle fenêtre.
  Drupal.behaviors.commonExternalLink = {
    attach(context) {
      const host = window.location.host.replace(/\./g, "\\.");
      const match = new RegExp(`(^http(s)?:\\/\\/(?!${host}))|(.*.pdf$)`);

      once(
        "commonExternalLink",
        "a:not(.language-link):not(.block-link):not(.selfish-link)",
        context,
      ).forEach((link) => {
        link.addEventListener("click", (event) => {
          const target = event.currentTarget;
          const { href } = target;
          if (href === "#") {
            return;
          }

          if (match.test(href) || target.rel === "external") {
            event.preventDefault();
            event.stopPropagation();
            window.open(href, "_blank");
          }
        });
      });
    },
  };

  // Auto-submit des filtres exposés Views (actualités, CO2, hydrogène,
  // méthanisation, communiqués de presse, publications, questions/réponses)
  // au changement d'un select.
  // Le formulaire exposé Views rend parfois une action relative
  // (ex. "medias/publications" sans "/" initial) : soumis depuis
  // l'URL de la vue elle-même, le navigateur la résout par
  // rapport au dossier courant et double le segment
  // (/medias/medias/...). On force l'action vers le chemin
  // absolu courant pour l'éviter.
  function submitExposedForm(submit) {
    const form = submit.closest("form");
    if (form) {
      form.setAttribute("action", window.location.pathname);
    }
    submit.click();
  }

  Drupal.behaviors.updateViewsFilters = {
    attach(context) {
      const VIEWS = [
        ".view-actualite",
        ".view-co2",
        ".view-hydrogene",
        ".view-methanisation",
        ".view-communiques-de-presse",
        ".view-publication",
        ".view-questions-reponses",
      ];

      const SELECTOR = VIEWS.map((view) => `${view} select`).join(", ");

      once("updateViewsFilters", SELECTOR, context).forEach((select) => {
        select.addEventListener("change", () => {
          document
            .querySelectorAll(
              ".form-actions input[type=submit].exposed-form-submit",
            )
            .forEach(submitExposedForm);
        });
      });

      // Bouton "Réinitialiser" des mêmes formulaires exposés Views : il
      // soumet directement le formulaire au clic (sans repasser par le
      // select ci-dessus), donc sans le correctif d'action il hérite du
      // même bug de résolution d'URL relative (/medias/medias/... au lieu
      // de /medias/ma-vue).
      const RESET_SELECTOR = VIEWS.map(
        (view) => `${view} [data-drupal-selector^="edit-reset"]`,
      ).join(", ");

      once("updateViewsFiltersReset", RESET_SELECTOR, context).forEach(
        (reset) => {
          reset.addEventListener("click", () => {
            const form = reset.closest("form");
            if (form) {
              form.setAttribute("action", window.location.pathname);
            }
          });
        },
      );
    },
  };

  // Filtres exposés Views (agenda, médiathèque, dossiers de presse...) :
  // auto-submit du formulaire au changement d'un select, et libellé du tri
  // par date renommé en dur (FR/EN).
  // Concerne seulement la vue : /medias/dossiers-de-presse et bloc mediatheque => à refacto !
  Drupal.behaviors.exposedForm = {
    attach(context) {
      const { lang } = document.documentElement;

      once(
        "exposedFormAutoSubmit",
        ".views-publications select",
        context,
      ).forEach((select) => {
        select.addEventListener("change", () => {
          // Le formulaire exposé Views rend parfois une action relative
          // (ex. "medias/publications" sans "/" initial) : soumis depuis
          // l'URL de la vue elle-même, le navigateur la résout par rapport
          // au dossier courant et double le segment (/medias/medias/...).
          // On force l'action vers le chemin absolu courant pour l'éviter.
          select.form.setAttribute("action", window.location.pathname);
          select.form.submit();
        });
      });

      once(
        "exposedFormSortLabel",
        ".form-item-sort-order label",
        context,
      ).forEach((label) => {
        label.textContent = lang === "fr" ? "PAR DATE" : "BY DATE";
      });
    },
  };

  Drupal.behaviors.multiSelectCustom = {
    attach(context) {
      once("multiSelectCustom", ".webform-custom-select", context).forEach(
        (webformCustomSelect) => {
          let multiSelect;
          let multiSelectBtn;

          function toggleDropdown() {
            const isDropdownExpanded =
              multiSelectBtn.getAttribute("aria-expanded") === "true";
            multiSelectBtn.setAttribute("aria-expanded", !isDropdownExpanded);
            webformCustomSelect.classList.toggle("-hidden");
          }

          function closeDropdown() {
            if (webformCustomSelect.classList.contains("-hidden")) return;
            multiSelectBtn.setAttribute("aria-expanded", "false");
            webformCustomSelect.classList.add("-hidden");
          }

          function init() {
            webformCustomSelect.classList.add("-hidden");

            const multiSelectHTML = `
              <div class="multiselect">
                <button type="button" aria-expanded="false" class="multiselect__btn">${Drupal.t("Sélectionner")}</button>
              </div>
            `;
            webformCustomSelect.insertAdjacentHTML(
              "beforebegin",
              multiSelectHTML,
            );

            multiSelect = webformCustomSelect.previousElementSibling;
            multiSelectBtn = multiSelect.querySelector(".multiselect__btn");
            multiSelect.insertAdjacentElement("beforeend", webformCustomSelect);
            multiSelectBtn.addEventListener("click", toggleDropdown);
          }

          window.addEventListener("load", init);
          window.addEventListener("click", (e) => {
            if (e.target.closest(".multiselect")) return;
            closeDropdown();
          });
          window.addEventListener("keydown", (e) => {
            if (e.code !== "Escape") return;
            closeDropdown();
          });
        },
      );
    },
  };

  Drupal.behaviors.rebranding = {
    attach(context) {
      once("rebranding", "body", context).forEach((page) => {
        const menuAccessibilite = page.querySelector(".menu--accessibilite");

        if (menuAccessibilite) menuAccessibilite.remove();
      });
    },
  };

  // Affiche/masque le bloc alerte (paragraphe "Alerte"), avec mémorisation
  // du choix de fermeture pour le reste de la session de navigation.
  Drupal.behaviors.alerte = {
    attach(context) {
      const myAlert = once("myAlert", ".bloc-alerte", context);

      if (!myAlert.length) {
        return;
      }

      const hidden = window.sessionStorage.getItem("affichage") === "0";
      myAlert.forEach((el) => {
        el.style.display = hidden ? "none" : "block";
      });

      const btnFermer = document.getElementById("btn-fermer");
      if (btnFermer) {
        btnFermer.addEventListener("click", () => {
          myAlert.forEach((el) => {
            el.style.display = "none";
          });
          window.sessionStorage.setItem("affichage", "0");
        });
      }

      const btnAlerte = document.getElementById("btn-alerte");
      if (btnAlerte) {
        btnAlerte.addEventListener("click", () => {
          window.sessionStorage.setItem("affichage", "0");
        });
      }
    },
  };

  // Navigation alphabétique du bloc "Abécédaire" (#glossaryAbecedaire).
  // Déselectionne visuellement un lien lettre.
  function removeSelectedClass(l) {
    l.classList.remove("ln-selected");
  }

  // Masque une carte (retrait du filtre courant).
  function hideCard(child) {
    child.classList.add("listNavHide");
    child.classList.remove("listNavShow");
  }

  // Affiche une carte (lettre nouvellement sélectionnée).
  function showCard(child) {
    child.classList.add("listNavShow");
    child.classList.remove("listNavHide");
  }

  Drupal.behaviors.abecedaire = {
    attach(context) {
      const TITLE_SELECTOR = ".abcedeaire-card-title";
      const LETTERS = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ];
      // Sur les appareils tactiles, un clic souris ne déclenche pas toujours
      // l'évènement 'click' : on écoute aussi 'touchend'.
      // Cf. https://github.com/esteinborn/jquery-listnav/issues/34
      const CLICK_EVENTS =
        document.ontouchstart !== null ? ["click"] : ["touchend", "click"];

      once("glossaryAbecedaire", "#glossaryAbecedaire", context).forEach(
        (list) => {
          const counts = {};
          let prevLetter = "";
          let isFirstClick = true;

          // Classe chaque carte avec sa première lettre (ln-<lettre>), déduite du titre
          Array.from(list.children).forEach((card) => {
            const titleEl = card.querySelector(TITLE_SELECTOR);
            const letter = titleEl
              ? titleEl.textContent.trim().toLowerCase().charAt(0)
              : "";

            if (!LETTERS.includes(letter)) return;

            card.classList.add(`ln-${letter}`);
            counts[letter] = (counts[letter] || 0) + 1;
          });

          // Ligne affichée quand une lettre n'a aucune carte correspondante
          const noMatch = document.createElement("li");
          noMatch.className = "ln-no-match listNavHide";
          list.appendChild(noMatch);

          // Construction de la nav A-Z, insérée juste avant la liste
          const nav = document.createElement("div");
          nav.id = `${list.id}-nav`;
          nav.className = "listNav";

          const lettersWrapper = document.createElement("div");
          lettersWrapper.className = "ln-letters";
          nav.appendChild(lettersWrapper);
          list.parentNode.insertBefore(nav, list);

          let links;

          // Sur mobile/tablette, la liste passe en scroll interne une fois filtrée
          function updateListOverflow() {
            const isTablet = window.matchMedia("(max-width: 991px)").matches;

            if (!isTablet) {
              list.style.height = "auto";
              return;
            }

            const isMobile = window.matchMedia("(max-width: 575px)").matches;
            list.style.overflowY = "scroll";
            list.style.overflowX = "hidden";
            list.style.height = isMobile ? "750px" : "400px";
          }

          function deselectLetterLinks() {
            links.forEach(removeSelectedClass);
          }

          function selectLetter(letter, link) {
            // Ignore les doublons d'évènement (touchend + click sur un même tap)
            if (prevLetter === letter) return;

            deselectLetterLinks();

            if (isFirstClick) {
              Array.from(list.children).forEach(hideCard);
              isFirstClick = false;
            } else if (prevLetter !== "") {
              list.querySelectorAll(`.ln-${prevLetter}`).forEach(hideCard);
            }

            const count = counts[letter] || 0;
            if (count > 0) {
              list.querySelectorAll(`.ln-${letter}`).forEach(showCard);
              noMatch.classList.add("listNavHide");
              noMatch.classList.remove("listNavShow");
              updateListOverflow();
            } else {
              noMatch.classList.add("listNavShow");
              noMatch.classList.remove("listNavHide");
            }

            prevLetter = letter;
            link.classList.add("ln-selected");
            link.blur();
          }

          // Lettre cliquée/tapée : déduite du data-attribute posé ci-dessous
          // lors de la création du lien (évite de dépendre de `link.className`,
          // qui accumule d'autres classes comme "ln-disabled"/"ln-last").
          function handleLetterClick(e) {
            e.preventDefault();
            const link = e.currentTarget;
            selectLetter(link.dataset.letter, link);
          }

          links = LETTERS.map((letter) => {
            const link = document.createElement("a");
            link.className = letter;
            link.href = "#";
            link.textContent = letter.toUpperCase();
            link.dataset.letter = letter;

            if (!counts[letter]) {
              link.classList.add("ln-disabled");
            }

            for (let j = 0; j < CLICK_EVENTS.length; j += 1) {
              link.addEventListener(CLICK_EVENTS[j], handleLetterClick);
            }

            lettersWrapper.appendChild(link);
            return link;
          });

          links[links.length - 1].classList.add("ln-last");

          // Au chargement, affiche directement la première lettre non vide
          for (let i = 0; i < LETTERS.length; i++) {
            if (counts[LETTERS[i]] > 0) {
              selectLetter(LETTERS[i], links[i]);
              break;
            }
          }
        },
      );
    },
  };

  // Personnalise le bandeau tarteaucitron une fois qu'il est présent dans le DOM
  // (le bandeau étant injecté de manière asynchrone par la librairie tarteaucitron,
  // on sonde le DOM jusqu'à son apparition)
  function customizeCookiesBanner() {
    const fr = document.documentElement.lang === "fr";

    const checkCookiesExist = setInterval(() => {
      const alertBig = document.querySelector("#tarteaucitronAlertBig");
      const ctaButton =
        alertBig && alertBig.querySelector(".tarteaucitronCTAButton");

      if (!ctaButton) {
        // l'encart des cookies n'est pas encore chargé dans le DOM, on reitere le test
        return;
      }

      // placer les boutons dans un wrapper pour simplifier stylisation
      const cookiesWrapper = document.createElement("div");
      cookiesWrapper.className = "cookiesWrapper";
      alertBig.appendChild(cookiesWrapper);

      const buttonWrapper = document.createElement("div");
      buttonWrapper.className = "cookieButtonWrapper";
      alertBig.querySelectorAll("button").forEach((button) => {
        buttonWrapper.appendChild(button);
      });
      cookiesWrapper.appendChild(buttonWrapper);

      const continueWrapper = document.createElement("div");
      continueWrapper.className = "continueWrapper";
      const continueButton = document.createElement("button");
      continueButton.className = "continueButton";
      continueButton.textContent = fr
        ? "Continuer sans accepter"
        : "Continue without accepting";
      continueButton.addEventListener("click", () => {
        window.continueWithoutAccepting(true);
      });
      continueWrapper.appendChild(continueButton);

      const disclaimerAlert = document.querySelector(
        "#tarteaucitronDisclaimerAlert",
      );
      if (disclaimerAlert && disclaimerAlert.parentNode) {
        disclaimerAlert.parentNode.insertBefore(
          continueWrapper,
          disclaimerAlert,
        );
      }

      // mesure d'audience
      const mesureTitle = document.createElement("div");
      mesureTitle.className = "mesureAudienceTitle tarteaucitronH2";
      const mesureDescription = document.querySelector(
        "#tarteaucitronDetailsanalytic",
      );
      const mesureTitleContainer = document.querySelector(
        "#tarteaucitronServicesTitle_analytic .tarteaucitronTitle",
      );
      if (mesureTitleContainer) {
        mesureTitleContainer.appendChild(mesureTitle);
      }
      if (fr) {
        mesureTitle.textContent = "Cookies de mesure d'audience";
        if (mesureDescription) {
          mesureDescription.textContent =
            "Les services de mesure d'audience permettent la bonne administration du site. Vous avez cependant la possibilité de vous opposer à leur usage.";
        }
      } else {
        mesureTitle.textContent = "Audience measurement cookies";
        if (mesureDescription) {
          mesureDescription.textContent =
            "The audience measurement services allow the proper administration of the site. However, you may oppose the setting of these cookies.";
        }
      }

      // cookies techniques
      const techTitle = document.createElement("div");
      techTitle.className = "techTitle tarteaucitronH2";
      const techDescription = document.createElement("div");
      techDescription.className = "techDescription";
      const mandatoryTitleButton = document.querySelector(
        "#tarteaucitronServicesTitle_mandatory .tarteaucitronTitle button",
      );
      const mandatoryDescription = document.querySelector(
        "#tarteaucitronServicesTitle_mandatory .tarteaucitronH3",
      );
      techTitle.textContent = mandatoryTitleButton
        ? mandatoryTitleButton.textContent
        : "";
      techDescription.textContent = mandatoryDescription
        ? mandatoryDescription.textContent
        : "";
      const techWrapper = document.createElement("div");
      techWrapper.className = "techWrapper";
      techWrapper.appendChild(techTitle);
      techWrapper.appendChild(techDescription);
      const mainLineOffset = document.querySelector(
        "#tarteaucitronMainLineOffset",
      );
      if (mainLineOffset) {
        mainLineOffset.appendChild(techWrapper);
      }

      clearInterval(checkCookiesExist);
      window.continueWithoutAccepting();
    }, 100);
  }

  // Bandeau cookies tarteaucitron : personnalisation du bandeau + jobs
  // youtube/keepeek/countly déclenchés à l'acceptation.
  Drupal.behaviors.disclaimer = {
    attach(context) {
      once("disclaimerBanner", "body", context).forEach(customizeCookiesBanner);

      once("disclaimerAllow", ".tarteaucitronAllow", context).forEach(
        (element) => {
          element.addEventListener("mousedown", () => {
            (tarteaucitron.job = tarteaucitron.job || []).push("youtube");
            (tarteaucitron.job = tarteaucitron.job || []).push("keepeek");
            (tarteaucitron.job = tarteaucitron.job || []).push("countly");
          });
        },
      );
    },
  };

  // Page "erreur" : redirige automatiquement vers le lien de retour
  // (#url-erreur) après 10 secondes si l'utilisateur ne clique pas avant.
  Drupal.behaviors.error = {
    attach(context) {
      once("errorRedirect", "#url-erreur", context).forEach((link) => {
        window.setTimeout(() => {
          window.location.href = link.href;
        }, 10000);
      });
    },
  };

  // Formulaire "Nous contacter" : repositionne les messages d'erreur
  // (.field-suffix) en sibling direct du champ pour que le CSS de
  // validation Bootstrap (.was-validated .form-control:invalid ~
  // .invalid-feedback) s'applique, y compris pour les textarea (wrappés
  // dans un .form-textarea-wrapper supplémentaire par Drupal), et active
  // la validation Bootstrap 4 sur les formulaires .needs-validation.
  Drupal.behaviors.nousContacter = {
    attach(context) {
      once("nousContacterFieldSuffix", ".field-suffix", context).forEach(
        (suffix) => {
          const previous = suffix.previousElementSibling;

          if (
            previous &&
            previous.classList.contains("form-textarea-wrapper")
          ) {
            previous.insertAdjacentHTML("beforeend", suffix.innerHTML);
          } else {
            suffix.insertAdjacentHTML("afterend", suffix.innerHTML);
          }

          suffix.remove();
        },
      );

      once("nousContacterValidation", ".needs-validation", context).forEach(
        (form) => {
          form.addEventListener("submit", (event) => {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
              // novalidate désactive le blocage/scroll/focus automatique du
              // navigateur sur le premier champ invalide : reportValidity()
              // le redéclenche manuellement (formulaires longs où le champ
              // en erreur, souligné en rouge, n'est sinon pas visible).
              form.reportValidity();
            }
            form.classList.add("was-validated");
          });
        },
      );
    },
  };

  // Médiathèque : masque la carte déjà mise en avant ailleurs sur la page
  // (sinon 4ᵉ carte par défaut), active le bon slide de la modale au clic,
  // et fait boucler le carousel "à la une" sans jamais atteindre sa fin.
  //
  // show.bs.modal / slide.bs.carousel sont des évènements Bootstrap 4
  // déclenchés uniquement via le bus interne de jQuery ($.Event, pas
  // dispatchEvent) : on garde jQuery pour les écouter et pour initialiser
  // le plugin carousel, le reste est natif.
  function openMediathequeModal(modal, event) {
    const button = event.relatedTarget;
    const recipient = button ? button.dataset.itemToActive : null;

    modal.querySelectorAll("#carousel-mediatheque .active").forEach((el) => {
      el.classList.remove("active");
    });

    if (recipient) {
      const activeItem = modal.querySelector(`#${recipient}`);
      if (activeItem) {
        activeItem.classList.add("active");
      }
    }

    jQuery("#carousel-mediatheque").carousel({ interval: false });

    setTimeout(() => {
      window.dispatchEvent(new Event("resize")); // force la mise à jour de la mise en page
    });
  }

  Drupal.behaviors.mediatheque = {
    attach(context) {
      once("mediathequeHideSelected", ".block-mediatheque", context).forEach(
        (block) => {
          const nodeSelected = block.querySelector(".node-selected");
          const contentToHide = nodeSelected ? nodeSelected.value : null;
          const target = contentToHide
            ? block.querySelector(`#${contentToHide}`)
            : null;

          if (target) {
            target.style.display = "none";
          } else {
            const rows = block.querySelectorAll(".views-row");
            if (rows[3]) {
              rows[3].style.display = "none";
            }
          }
        },
      );

      once("mediathequeModal", "#exampleModal", context).forEach((modal) => {
        jQuery(modal).on("show.bs.modal", (event) =>
          openMediathequeModal(modal, event),
        );
      });

      // Déplace les premiers slides à la fin quand on est sur les derniers,
      // pour ne jamais atteindre la fin du carousel.
      once("carouselALaUne", "#carousel-a-la-une", context).forEach(
        (carousel) => {
          jQuery(carousel).on("slide.bs.carousel", (event) => {
            const itemsPerSlide = 3;
            const items = carousel.querySelectorAll(".carousel-item");
            const itemsContainer = carousel.querySelector(".carousel-inner");
            const relatedIndex = Array.prototype.indexOf.call(
              items,
              event.relatedTarget,
            );
            const missing = itemsPerSlide - (items.length - relatedIndex);

            for (let i = 0; i < missing; i += 1) {
              const currentItems = carousel.querySelectorAll(".carousel-item");
              const item =
                event.direction === "left" ? currentItems[i] : currentItems[0];
              if (item) {
                itemsContainer.appendChild(item);
              }
            }
          });
        },
      );
    },
  };

  // Bandeau d'alerte (paragraphe "Bandeau alerte") : affichage/masquage
  // mémorisé pour la session, comme pour Drupal.behaviors.alerte ci-dessus.
  // NB : ce comportement partage la même clé sessionStorage ('affichage')
  // que Drupal.behaviors.alerte — fermer l'un masque aussi l'autre au
  // chargement suivant si les deux paragraphes coexistent sur la page.
  function hideBandeauAlerte(banner) {
    banner.style.display = "none";
  }

  Drupal.behaviors.bandeauAlerte = {
    attach(context) {
      once("bandeauAlerteDisplay", ".bloc-bandeau-alerte", context).forEach(
        (banner) => {
          if (window.sessionStorage.getItem("affichage") !== "0") {
            banner.style.display = "block";
          }
        },
      );

      once("bandeauAlerteFermer", "#btn-fermer-bandeau", context).forEach(
        (btn) => {
          btn.addEventListener("click", () => {
            document
              .querySelectorAll(".bloc-bandeau-alerte")
              .forEach(hideBandeauAlerte);
            window.sessionStorage.setItem("affichage", "0");
          });
        },
      );

      once("bandeauAlerteBtnAlerte", "#btn-alerte", context).forEach((btn) => {
        btn.addEventListener("click", () => {
          window.sessionStorage.setItem("affichage", "0");
        });
      });
    },
  };

  // Lecteur audio "maison" du paragraphe Podcast : pas de librairie tierce,
  // juste des fonctions globales appelées depuis des attributs on* inline
  // posés par le twig (onclick, onchange, onended, onloadedmetadata,
  // ontimeupdate) sur <audio id="aud-{id}">, <input id="dur-{id}"> et
  // <button id="aud-{id}-play-pause">.
  function formatDuration(seconds) {
    if (Number.isNaN(seconds)) {
      return false;
    }
    const totalSeconds = Math.floor(seconds);
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;
    return `${minutes}:${remainingSeconds >= 10 ? remainingSeconds : `0${remainingSeconds}`}`;
  }
  window.duration = formatDuration;

  // Initialise les libellés de durée (0:00 / durée totale) une fois les
  // métadonnées audio chargées.
  window.mDur = function mDur(id) {
    const audio = document.getElementById(`aud-${id}`);
    const range = document.getElementById(`dur-${id}`);

    range.max = audio.duration;
    document.querySelector(`#audio-${id} .end`).textContent = formatDuration(
      audio.duration,
    );
    document.querySelector(`#audio-${id} .start`).textContent = "0:00";
  };

  // Met à jour le curseur, la barre de progression et le temps écoulé
  // pendant la lecture.
  window.mPlay = function mPlay(id) {
    const audio = document.getElementById(`aud-${id}`);
    const range = document.getElementById(`dur-${id}`);
    const filler = document.getElementById(`filler-${id}`);

    if (!range.classList.contains("pressed")) {
      range.value = audio.currentTime;
    }

    filler.style.width = `${(range.value / audio.duration) * 100}%`;

    const elapsed = formatDuration(audio.currentTime);
    if (elapsed) {
      document.querySelector(`#audio-${id} .start`).textContent = elapsed;
    }
  };

  // Déplace la lecture au point choisi sur le curseur.
  window.mSet = function mSet(id) {
    const range = document.getElementById(`dur-${id}`);
    const audio = document.getElementById(`aud-${id}`);

    audio.currentTime = range.value;

    const elapsed = formatDuration(audio.currentTime);
    if (elapsed) {
      document.querySelector(`#audio-${id} .start`).textContent = elapsed;
    }
  };

  // Remet le bouton play/pause à l'état "pause" à la fin de la lecture.
  window.mEend = function mEend(id) {
    const button = document.getElementById(`aud-${id}-play-pause`);
    if (button) {
      button.classList.remove("play");
      button.classList.add("pause");
    }
  };

  // Joue/mets en pause le podcast cliqué, en coupant les autres podcasts
  // éventuellement déjà en cours de lecture sur la page.
  window.aud_play_pause = function audPlayPause(elm, id) {
    const audio = document.getElementById(`aud-${id}`);

    if (audio.paused) {
      document.querySelectorAll(".audio").forEach((otherAudio) => {
        if (!otherAudio.paused) {
          otherAudio.pause();
          const otherButton = document.getElementById(
            `${otherAudio.id}-play-pause`,
          );
          if (otherButton) {
            otherButton.classList.remove("play");
            otherButton.classList.add("pause");
          }
        }
      });

      audio.play();
      elm.classList.remove("pause");
      elm.classList.add("play");
    } else {
      elm.classList.remove("play");
      elm.classList.add("pause");
      audio.pause();
    }
  };

  Drupal.behaviors.animationAudio = {
    attach(context) {
      once("animationAudioSlider", ".slider", context).forEach((slider) => {
        slider.addEventListener("mousedown", () =>
          slider.classList.add("pressed"),
        );
        slider.addEventListener("mouseup", () =>
          slider.classList.remove("pressed"),
        );
      });
    },
  };

  // Overlay de recherche plein écran (icône loupe du header) : ouverture/
  // fermeture + blocage du scroll de la page pendant que l'overlay est ouvert.
  function expandSearchOverlay(overlay) {
    overlay.style.width = "100%";
  }

  Drupal.behaviors.openSearchOverlay = {
    attach(context) {
      once("openOverlay", "[data-event=open-overlay]", context).forEach(
        (element) => {
          element.addEventListener("click", () => {
            document
              .querySelectorAll(".overlay-recherche")
              .forEach(expandSearchOverlay);
            document.body.classList.add("overflow-hidden");
          });
        },
      );
    },
  };

  function collapseSearchOverlay(overlay) {
    overlay.style.width = "0%";
  }

  Drupal.behaviors.closeSearchOverlay = {
    attach(context) {
      once("closeOverlay", "[data-event=close-overlay]", context).forEach(
        (element) => {
          element.addEventListener("click", () => {
            document
              .querySelectorAll(".overlay-recherche")
              .forEach(collapseSearchOverlay);
            document.body.classList.remove("overflow-hidden");
          });
        },
      );
    },
  };

  // Equivalent vanilla de jQuery .height() : hauteur du contenu seul,
  // sans padding ni bordure (contrairement à clientHeight qui inclut le padding).
  function contentHeight(el) {
    const style = getComputedStyle(el);
    const paddingTop = parseFloat(style.paddingTop) || 0;
    const paddingBottom = parseFloat(style.paddingBottom) || 0;
    return el.clientHeight - paddingTop - paddingBottom;
  }

  // En-tête vidéo : remonte le bloc vidéo pour qu'il chevauche le bandeau
  // titre/citation au-dessus, en compensant le nombre de lignes que prend
  // la citation (field_citation, .accroche-page) une fois rendue — une
  // citation plus longue (donc plus haute) remonte davantage la vidéo pour
  // garder l'alignement visuel. Sans effet sur mobile : la règle CSS
  // .video { margin-top: -180px !important; } (en-tete-video.scss) prend
  // le dessus sur ce style inline de toute façon.
  Drupal.behaviors.enteteVideo = {
    attach(context) {
      once("enteteVideoPosition", ".en-tete-video", context).forEach(
        (entete) => {
          const accroche = entete.querySelector(".accroche-page");
          const video = entete.querySelector(".video");

          if (!video) {
            return;
          }

          let initialVideoTopMargin = -220; // en absence de l'accroche
          let lineHeight = 0;
          let nbLinesAccroche = 0;

          if (accroche) {
            initialVideoTopMargin = -283; // en présence de l'accroche
            lineHeight = parseInt(getComputedStyle(accroche).lineHeight, 10);
            nbLinesAccroche = Math.round(contentHeight(accroche) / lineHeight);
          }

          video.style.marginTop = `${initialVideoTopMargin - lineHeight * nbLinesAccroche}px`;
        },
      );
    },
  };

  // Scrollytelling "Dispatch" : à gauche une liste de blocs de texte, à
  // droite (desktop only) une image "collée" à l'écran qui fait un fondu
  // enchaîné vers l'image suivante au fil du scroll. Un `once()` par
  // instance de `.colonne-images-scrollable`, pour ne jamais mélanger les
  // images de deux paragraphes "Dispatch" présents sur la même page
  // (l'ancienne version jQuery mélangeait tout dès qu'il y en avait plus
  // d'un, faute de scoping par instance).
  Drupal.behaviors.paragraphDispatch = {
    attach(context) {
      once("dispatch", ".colonne-images-scrollable", context).forEach(
        (colonneImagesScrollable) => {
          const screenSizedContainer = colonneImagesScrollable.querySelector(
            ".screen-sized-container",
          );
          const imageScrollable =
            screenSizedContainer.querySelector(".images-scrollable");
          const imgs = imageScrollable.querySelectorAll(
            ".image-dispatch-container",
          );
          const imgHeight = contentHeight(imageScrollable);
          const dispatchReducedHeight =
            colonneImagesScrollable.closest(".bloc-dispatch");

          function updatePosition() {
            const nbImg = imgs.length;
            if (!nbImg) {
              return;
            }

            // Uniquement en vue desktop
            if (!window.matchMedia("(min-width: 992px)").matches) {
              return;
            }

            const windowHeight = window.innerHeight;
            const scrollPerImg = windowHeight;
            const totalImgsHeight = imgs.length * scrollPerImg;

            const currentScroll = window.scrollY;
            // Valeur top entre le bloc image et le haut de la page
            const imageScrollableTopOrigin =
              colonneImagesScrollable.getBoundingClientRect().top +
              window.scrollY;
            // Valeur top du bloc lorsqu'il doit suivre le défilement de la page
            const imageScrollableTop =
              (windowHeight - contentHeight(imageScrollable)) / 2;
            // Valeur à partir de laquelle le bloc doit rester figé sur la page
            const firstImgTopScrollPosition = imageScrollableTopOrigin;
            // Position par rapport à la bordure gauche de la page
            const imageScrollableLeft =
              imageScrollable.getBoundingClientRect().left + window.scrollX;
            // Position à partir de laquelle le bloc ne doit plus suivre le scroll
            const lastImgTopPos =
              firstImgTopScrollPosition + (totalImgsHeight - scrollPerImg);

            const isContainerFlexEnd =
              colonneImagesScrollable.classList.contains("flex-end");

            if (
              currentScroll >= firstImgTopScrollPosition &&
              currentScroll < lastImgTopPos
            ) {
              // on est en plein dans une animation : on fixe le container de
              // l'image au milieu de l'écran
              imageScrollable.style.position = "fixed";
              imageScrollable.style.top = `${imageScrollableTop}px`;
              imageScrollable.style.left = `${imageScrollableLeft}px`;

              if (isContainerFlexEnd) {
                colonneImagesScrollable.classList.remove("flex-end");
              }

              // calcul du nombre de pixels scrollés à l'intérieur des images
              const progressTotal = currentScroll - firstImgTopScrollPosition;
              // index de l'image du haut / du bas de l'animation courante
              const indexPrevious = Math.floor(progressTotal / scrollPerImg);
              const indexNext = indexPrevious + 1;
              const imgNext = imgs[indexNext];

              // on superpose toutes les images précédentes, on cache les suivantes
              for (let i = 0; i < imgs.length; i += 1) {
                imgs[i].style.zIndex = i <= indexNext ? i + 1 : -1;
                imgs[i].style.clipPath = "none";
              }

              // calcul du recouvrement entre les 2 images
              const scrollCurrentIndex =
                progressTotal - indexPrevious * scrollPerImg;
              const marginAboveImg = (scrollPerImg - imgHeight) / 2;
              let progressCurrentIndex = scrollCurrentIndex - marginAboveImg;
              if (progressCurrentIndex < 0) {
                progressCurrentIndex = 0;
              } else if (progressCurrentIndex > imgHeight) {
                progressCurrentIndex = imgHeight;
              }

              // quand on est à 0px de progression, on ne veut pas afficher
              // l'image du bas : le clip-path fait donc la hauteur totale de
              // l'image plutôt que 0
              const progressNextImage = Math.max(
                0,
                imgHeight - progressCurrentIndex,
              );
              if (imgNext) {
                imgNext.style.clipPath = `inset(${progressNextImage}px 0 0 0)`;
              }

              if (dispatchReducedHeight) {
                dispatchReducedHeight.classList.remove(
                  "dispatch-reduced-height",
                );
              }
            } else if (currentScroll >= lastImgTopPos) {
              // Si on est en bas du paragraphe, le bloc ne doit plus suivre le scroll
              imageScrollable.style.position = "static";
              imageScrollable.style.left = "unset";

              if (!isContainerFlexEnd) {
                colonneImagesScrollable.classList.add("flex-end");
              }

              // on superpose toutes les images pour afficher la dernière
              for (let i = 0; i < imgs.length; i += 1) {
                imgs[i].style.zIndex = i + 1;
                imgs[i].style.clipPath = "none";
              }

              if (dispatchReducedHeight) {
                const parent = dispatchReducedHeight.parentElement;
                const fieldItem = parent
                  ? parent.closest(".node__content .field .field__item")
                  : null;
                if (!fieldItem || !fieldItem.matches(":last-child")) {
                  // dispatch n'est pas le dernier bloc de la page : on réduit
                  // sa hauteur pour l'approcher du bloc suivant
                  dispatchReducedHeight.classList.add(
                    "dispatch-reduced-height",
                  );
                }
                // sinon (dernier bloc de la page), il garde sa hauteur par défaut
              }
            } else {
              // Si on est tout en haut de la page, le bloc ne doit plus suivre
              // le scroll : on diminue sa hauteur pour réduire l'espace avec
              // le bloc précédent
              if (dispatchReducedHeight) {
                dispatchReducedHeight.classList.add("dispatch-reduced-height");
              }
              imageScrollable.style.position = "static";
              imageScrollable.style.left = "unset";

              if (isContainerFlexEnd) {
                colonneImagesScrollable.classList.remove("flex-end");
              }

              // on cache toutes les images, puis on affiche la première
              for (let i = 0; i < imgs.length; i += 1) {
                imgs[i].style.zIndex = -1;
                imgs[i].style.clipPath = "none";
              }
              if (imgs[0]) {
                imgs[0].style.zIndex = 1;
              }
            }
          }

          // Un seul recalcul par frame, même si plusieurs évènements scroll
          // arrivent entre-temps (évite les lectures/écritures DOM en rafale).
          let ticking = false;
          function onScrollAnimationFrame() {
            updatePosition();
            ticking = false;
          }

          window.addEventListener("scroll", () => {
            if (ticking) {
              return;
            }
            ticking = true;
            window.requestAnimationFrame(onScrollAnimationFrame);
          });
        },
      );
    },
  };

  // Carousel "Chiffres clés" : Bootstrap n'affiche qu'un .carousel-item par
  // slide, on clone le 1er enfant des items suivants dans chaque slide pour
  // simuler plusieurs cartes visibles à la fois, et on gère la désactivation
  // des flèches prev/next en bout de course (le clonage rend les toutes
  // dernières slides "creuses").
  Drupal.behaviors.chiffresClefs = {
    attach(context) {
      once(
        "chiffresCarouselClone",
        ".carousel .carousel-inner-en-chiffre .carousel-item",
        context,
      ).forEach((item) => {
        const minPerSlide = 4;
        let next = item.nextElementSibling;

        if (next && next.firstElementChild) {
          item.appendChild(next.firstElementChild.cloneNode(true));
        }
        for (let i = 0; i < minPerSlide; i += 1) {
          next = next ? next.nextElementSibling : null;
          if (next && next.firstElementChild) {
            item.appendChild(next.firstElementChild.cloneNode(true));
          }
        }
      });

      // Bloque la navigation une fois qu'on atteint les slides "creuses"
      // (le clonage plus haut n'a plus assez d'items suivants pour les
      // remplir), et bascule l'état visuel de la flèche "suivant" en
      // conséquence. `slide.bs.carousel` se déclenche avant CHAQUE
      // changement de slide, quel que soit le déclencheur (flèche cliquée,
      // swipe tactile, clavier) — un seul verrou ici couvre tous les cas,
      // contrairement à l'ancien code qui ne gérait que le clic sur la
      // flèche (+ un garde-fou tactile séparé, approximatif, qui neutralisait
      // le swipe sans jamais bloquer proprement la transition).
      once("chiffresCarouselBoundary", ".recipeCarousel", context).forEach(
        (wrapper) => {
          const nextControl = wrapper.querySelector(".carousel-control-next");
          if (!nextControl) {
            return;
          }

          const paragrapheId = wrapper.id.slice(wrapper.id.indexOf("-") + 1);
          // getElementsByClassName (et non querySelectorAll) : paragrapheId
          // est purement numérique (ex. "42"), or un sélecteur CSS de classe
          // ne peut pas commencer par un chiffre sans échappement —
          // querySelectorAll('.42') lève une SyntaxError. getElementsByClassName
          // ne parse pas de sélecteur CSS, il matche le nom de classe tel quel.
          const totalItems =
            document.getElementsByClassName(paragrapheId).length;

          // 4 cartes visibles à la fois en desktop (grille .col-lg-3), 1 seule
          // en dessous (mobile/tablette, confirmé à l'usage) : on ne peut
          // avancer que tant qu'il reste au moins une carte "neuve" à révéler.
          function lastUsableIndex() {
            const itemsPerView = window.matchMedia("(min-width: 992px)").matches
              ? 4
              : 1;
            return Math.max(0, totalItems - itemsPerView);
          }

          function applyBoundaryState(currentIndex) {
            if (currentIndex >= lastUsableIndex()) {
              nextControl.removeAttribute("href");
            } else if (!nextControl.hasAttribute("href")) {
              nextControl.setAttribute("href", `#${wrapper.id}`);
            }
          }

          // Etat initial : si tout tient déjà dans la vue, la flèche
          // "suivant" est désactivée dès le chargement, sans attendre un
          // premier clic.
          applyBoundaryState(0);

          jQuery(wrapper).on("slide.bs.carousel", (event) => {
            if (event.to > lastUsableIndex()) {
              event.preventDefault();
              nextControl.removeAttribute("href");
              return;
            }

            applyBoundaryState(event.to);
          });
        },
      );
    },
  };

  // Swipe tactile du carousel "Caroussel" (#carouselParagraph). Le swipe
  // natif de Bootstrap 4 (touch: true par défaut) ne suffit pas en pratique
  // sur ce carousel (constaté à l'usage après suppression du bloc jQuery
  // équivalent) : on restaure le geste en vanilla, en gardant .carousel()
  // (API du plugin) pour la navigation elle-même.
  Drupal.behaviors.carouselSwipe = {
    attach(context) {
      once("carouselSwipe", "#carouselParagraph", context).forEach(
        (carousel) => {
          let xClick = 0;

          function onTouchMove(event) {
            const xMove = event.touches[0].pageX;
            if (Math.floor(xClick - xMove) > 5) {
              jQuery(carousel).carousel("next");
            } else if (Math.floor(xClick - xMove) < -5) {
              jQuery(carousel).carousel("prev");
            }
          }

          carousel.addEventListener("touchstart", (event) => {
            xClick = event.touches[0].pageX;
            carousel.addEventListener("touchmove", onTouchMove, { once: true });
          });

          carousel.addEventListener("touchend", () => {
            carousel.removeEventListener("touchmove", onTouchMove);
          });
        },
      );
    },
  };

  // Carousel "en-tête" (a-la-une, caroussel-theme-edp, en-tete-caroussel,
  // caroussel-les-bienfaits) : synchronise le carousel mobile compagnon,
  // et met à jour la barre de progression + le compteur d'étape.
  // slide.bs.carousel est un évènement jQuery-only de Bootstrap 4 (comme
  // vu précédemment) : on garde jQuery pour l'écoute et pour piloter le
  // carousel mobile via son API (.carousel()), le reste est vanilla.
  // Ne dépend d'aucune variable propre à l'instance `carousel` : synchronise
  // toujours le carousel mobile dédié (#carousel-en-tete-mobile) et la
  // progression globale, quel que soit le carousel desktop qui a déclenché
  // l'évènement.
  function syncCarouselEnteteMobile(event) {
    jQuery("#carousel-en-tete-mobile")
      .carousel()
      .carousel(event.direction === "left" ? "next" : "prev");

    const totalItems = document.querySelectorAll(
      ".carousel-en-tete.vue-desktop .carousel-item",
    ).length;
    const step = event.to + 1;
    const percent = (step / totalItems) * 100;

    const progressBar = document.querySelector(
      ".progress-en-tete-carousel .progress-bar",
    );
    if (progressBar) {
      progressBar.style.width = `${percent}%`;
    }

    const stepNumber = step < 10 ? `0${step}` : `${step}`;
    document
      .querySelectorAll(
        ".suivi-carousel-en-tete .indice-to-change span, .suivi-carousel-en-tete .indice-to-change-mobile span",
      )
      .forEach((el) => {
        el.textContent = stepNumber;
      });

    document
      .querySelectorAll(".suivi-carousel-en-tete .indice-slite-en-tete")
      .forEach((el) => {
        el.classList.toggle("bold", step === totalItems);
      });
  }

  Drupal.behaviors.carouselEntete = {
    attach(context) {
      once("carouselEntete", "#carousel-en-tete", context).forEach(
        (carousel) => {
          jQuery(carousel).on("slide.bs.carousel", syncCarouselEnteteMobile);
        },
      );
    },
  };

  // Swipe tactile du carousel "Chiffres clés" (.recipeCarousel). Même souci
  // que #carouselParagraph ci-dessus : le swipe natif de Bootstrap 4 ne
  // suffit pas en pratique sur ce carousel (constaté après suppression du
  // swipe custom d'en-chiffres.js, censé faire doublon) : on le restaure
  // en vanilla, par instance de carousel (plusieurs "Chiffres clés"
  // possibles sur une même page).
  Drupal.behaviors.chiffresSwipe = {
    attach(context) {
      once("chiffresSwipe", ".recipeCarousel", context).forEach((carousel) => {
        let xClick = 0;

        function onTouchMove(event) {
          const xMove = event.touches[0].pageX;
          if (Math.floor(xClick - xMove) > 5) {
            jQuery(carousel).carousel("next");
          } else if (Math.floor(xClick - xMove) < -5) {
            jQuery(carousel).carousel("prev");
          }
        }

        carousel.addEventListener("touchstart", (event) => {
          xClick = event.touches[0].pageX;
          carousel.addEventListener("touchmove", onTouchMove, { once: true });
        });

        carousel.addEventListener("touchend", () => {
          carousel.removeEventListener("touchmove", onTouchMove);
        });
      });
    },
  };

  // Témoignages (vue "Nos collaborateurs témoignent") : anime l'apparition
  // au scroll et ajuste des classes de mise en page selon le motif
  // photo/vidéo de la grille (répété tous les 6 éléments), + autoplay des
  // vidéos au clic.
  function handleTemoignageAnimations() {
    if (!window.matchMedia("(min-width: 992px)").matches) {
      return;
    }
    const positionBottomScreen = window.scrollY + window.innerHeight;
    document
      .querySelectorAll(".temoignage .show-on-scroll.not-scrolled-yet")
      .forEach((el) => {
        const temoignageTopOrigin =
          el.getBoundingClientRect().top + window.scrollY;
        if (positionBottomScreen > temoignageTopOrigin) {
          el.classList.add("scrolled");
          el.classList.remove("not-scrolled-yet");
        }
      });
  }

  function FixTemoignagesDisplay(context) {
    document.querySelectorAll(".temoignage .black-color").forEach((el) => {
      el.classList.add("p-0");
    });

    document.querySelectorAll("a").forEach((link) => {
      if (link.textContent.includes("témoignage")) {
        link.title =
          "Cliquer pour afficher plus de témoignages de nos collaborateurs";
      }
    });

    once("temoignageBoxVideo", ".box-video", context).forEach((box) => {
      box.addEventListener("click", (event) => {
        box.classList.add("open");
        const iframe = box.querySelector("iframe");
        if (iframe) {
          const playButton = box.querySelector(".bg-video");
          if (playButton) {
            playButton.style.display = "none";
          }
          iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
          iframe.src += iframe.src.includes("?")
            ? "&autoplay=1"
            : "?autoplay=1";
          iframe.muted = false;
        }
        event.preventDefault();
      });
    });

    const temoignages = Array.from(
      document.querySelectorAll(".temoignages .temoignage"),
    );
    const nbElements = temoignages.length;

    const sousTitre = document.querySelector(".sous-titre");
    const top = (sousTitre ? sousTitre.offsetHeight : 0) + 190;
    const bottom = top + 40;

    const first = temoignages[0];
    if (first) {
      const typeMedia = first.dataset.typeElm;
      if (typeMedia === '"video"' && first.style.top !== "0px") {
        first.style.top = `${top}px`;
        first.style.marginBottom = `${bottom}px`;
      }
      if (typeMedia === '"photo"' && first.style.top === "0px") {
        const scrollDown = document.querySelector(".temoignage .scroll-down");
        if (scrollDown) {
          scrollDown.style.top = "188px";
        }
      }
    }

    for (let i = 5; i < nbElements; i += 6) {
      const typeMedia = temoignages[i].dataset.typeElm;
      const typeMediaSuiv = temoignages[i + 1]
        ? temoignages[i + 1].dataset.typeElm
        : null;
      const element = temoignages[i];
      if (typeMediaSuiv != null) {
        if (typeMedia === '"photo"') {
          element.classList.remove("css-temoignage-6-photo");
          element.classList.add(
            typeMediaSuiv === '"video"'
              ? "css-temoignage-left-photo-video"
              : "css-temoignage-left-photo-photo",
          );
        } else {
          element.classList.remove("css-temoignage-6-video");
          element.classList.add("css-temoignage-left-video");
        }
      }
    }

    for (let i = 6; i < nbElements; i += 6) {
      const typeMedia = temoignages[i].dataset.typeElm;
      const typeMediaPrev = temoignages[i - 1]
        ? temoignages[i - 1].dataset.typeElm
        : null;
      const typeMediaSuiv = temoignages[i + 1]
        ? temoignages[i + 1].dataset.typeElm
        : null;
      const element = temoignages[i];

      if (typeMedia === '"photo"') {
        element.classList.remove("css-temoignage-1-photo");
        element.classList.add(
          typeMediaPrev === '"photo"'
            ? "css-temoignage-right-photo-photo"
            : "css-temoignage-right-photo-video",
        );
      } else if (typeMediaPrev === '"photo"') {
        element.classList.remove("css-temoignage-1-video");
        element.classList.add("css-temoignage-right-video-photo");
        if (typeMediaSuiv == null) {
          element.style.marginBottom = "0";
        }
      } else {
        element.classList.remove("css-temoignage-1-video");
        element.classList.add("css-temoignage-right-video-video");
      }
    }

    for (let i = 1; i < nbElements; i += 1) {
      const typeMediaSuiv = temoignages[i + 1]
        ? temoignages[i + 1].dataset.typeElm
        : null;
      const element = temoignages[i];
      if (
        typeMediaSuiv == null &&
        element.classList.contains("css-temoignage-left-photo-video")
      ) {
        element.style.top = "0";
      }
    }
  }

  Drupal.behaviors.temoignage = {
    attach(context) {
      once("temoignageAnimations", "body", context).forEach(() => {
        window.addEventListener("scroll", handleTemoignageAnimations);
        window.addEventListener("resize", handleTemoignageAnimations);
        // Vérifie les positions toutes les secondes, en filet de sécurité
        // pour éviter qu'un bug d'affichage ne persiste.
        setInterval(handleTemoignageAnimations, 1000);
      });

      FixTemoignagesDisplay(context);
    },
  };

  // Ré-applique la mise en forme quand du contenu est ajouté par
  // l'infinite-scroll de la vue.
  Drupal.behaviors.infiniteScrollAddClass = {
    attach(context) {
      FixTemoignagesDisplay(context);
    },
  };

  // Formulaire "EIC" (webform custom) : une dizaine d'ajustements
  // indépendants, tous protégés par des `if (getElementById(...))` qui ne
  // matchent que sur ce formulaire précis — inoffensif sur les autres
  // pages malgré l'attach_library posé sur tout champ email/texte.
  Drupal.behaviors.webformEic = {
    attach(context) {
      once("webformEmailColor", "#edit-email", context).forEach((email) => {
        email.addEventListener("input", () => {
          email.setAttribute("style", "color: #3c4f69!important;");
        });
      });
      once("webformEmailColorSubmit", "#edit-actions-submit", context).forEach(
        (submit) => {
          submit.addEventListener("click", () => {
            const email = document.getElementById("edit-email");
            if (email) {
              email.setAttribute("style", "color: #3c4f69");
            }
          });
        },
      );

      // Formulaire EIC : marge négative si la case CGU EIC est présente.
      once("webformEicMargin", ".bloc-formulaire", context).forEach((bloc) => {
        if (document.getElementById("edit-checkbox-cgu--description")) {
          bloc.style.setProperty("margin-left", "-3rem", "important");
        }
      });

      // Tooltips d'aide (le "?" à côté d'un champ). Webform gère ça
      // nativement via Tippy.js (webform.element.help.js), mais cette lib
      // n'est jamais chargée sur ce site (`if (!window.tippy) return;`) :
      // le natif est donc mort. Le texte d'aide vit dans l'attribut
      // `data-webform-help` de l'élément lui-même (pas dans un <span>
      // sibling comme l'ancien code le supposait) : on construit le
      // tooltip depuis cet attribut.
      once("webformElementHelp", ".webform-element-help", context).forEach(
        (help) => {
          const helpHtml = help.getAttribute("data-webform-help");
          if (!helpHtml) {
            return;
          }

          const tooltip = document.createElement("span");
          tooltip.className = "custom-tooltip";
          tooltip.style.display = "none";
          tooltip.innerHTML = helpHtml;
          help.insertAdjacentElement("afterend", tooltip);

          help.addEventListener("click", (event) => {
            event.preventDefault();
            const isOpen = tooltip.style.display === "block";
            tooltip.style.display = isOpen ? "none" : "block";
            help.classList.toggle("tooltip-hover", !isOpen);
            help.classList.toggle("tooltip-unhover", isOpen);
          });
        },
      );

      // Formulaire EIC : affiche l'erreur si aucune case "entités" cochée
      // (au clic sur une case et à la soumission).
      const checkEntitesError = () => {
        const items = document.querySelectorAll(
          ".webform-options-display-buttons input",
        );
        const feedback = document.querySelector(
          "#edit-checkbox-entites--wrapper .fieldset-wrapper .invalid-feedback",
        );
        if (!feedback) {
          return;
        }
        const allUnchecked =
          items.length > 0 && Array.from(items).every((item) => !item.checked);
        feedback.style.display = allUnchecked ? "block" : "none";
      };

      once(
        "webformEntitesCheck",
        ".webform-options-display-buttons input",
        context,
      ).forEach((item) => {
        item.addEventListener("click", checkEntitesError);
      });
      once(
        "webformEntitesSubmitCheck",
        "#edit-actions-submit",
        context,
      ).forEach((submit) => {
        submit.addEventListener("click", checkEntitesError);
      });

      // Formulaire EIC : vérifie que les 2 champs de confirmation d'email correspondent.
      if (document.getElementById("edit-e-mail-mail-2")) {
        once(
          "webformEmailConfirm",
          "#edit-e-mail-mail-1, #edit-e-mail-mail-2",
          context,
        ).forEach((field) => {
          field.addEventListener("keyup", () => {
            const fst = document.getElementById("edit-e-mail-mail-1").value;
            const sec = document.getElementById("edit-e-mail-mail-2").value;
            const feedback = document.querySelector(
              ".form-item-e-mail-mail-2 .invalid-feedback",
            );
            if (feedback) {
              feedback.style.display = sec !== fst ? "block" : "none";
            }
          });
        });
      }

      // Texte grisé "facultatif" déplacé dans le <legend> d'un fieldset.
      once(
        "webformFacultatifLegend",
        "#edit-checkbox-entites--wrapper",
        context,
      ).forEach((wrapper) => {
        const legend = wrapper.getElementsByTagName("legend")[0];
        const facultatif = document.getElementById(
          "edit-checkbox-entites--wrapper--description",
        );
        if (legend && facultatif) {
          const span = document.createElement("span");
          span.className = "facultatif";
          span.innerText = ` ${facultatif.innerText}`;
          legend.append(span);
          facultatif.style.display = "none";
        }
      });

      // Texte grisé "facultatif" déplacé après le label des champs texte
      // (avant le tooltip d'aide si présent).
      document.querySelectorAll("label").forEach((label) => {
        const next = label.nextElementSibling;
        if (
          label.firstElementChild &&
          next &&
          next.classList.contains("facultatif")
        ) {
          if (
            label.firstElementChild.classList.contains("webform-element-help")
          ) {
            label.insertBefore(next, label.firstElementChild);
          } else {
            label.append(next);
          }
        }
      });

      // Selects "required" custom : couleur de bordure selon la présence
      // d'un message d'erreur associé.
      // NB : cible ".chosen-container", le plugin Chosen — jamais chargé
      // sur ce site (fichier orphelin déjà supprimé) : cette logique est
      // donc déjà inerte aujourd'hui, conservée telle quelle par fidélité.
      function updateSelectBorder(select) {
        const chosenContainer = select.nextElementSibling;
        if (
          !chosenContainer ||
          !chosenContainer.classList.contains("chosen-container")
        ) {
          return;
        }
        const errorOnSelect = chosenContainer.nextElementSibling;
        const isError =
          errorOnSelect &&
          (getComputedStyle(errorOnSelect).display === "block" ||
            select.querySelector("option:first-child:checked"));
        const chosenSingle = chosenContainer.querySelector(".chosen-single");
        if (chosenSingle) {
          chosenSingle.classList.toggle("invalid-border", !!isError);
          chosenSingle.classList.toggle("valid-border", !isError);
        }
      }

      once("webformSelectBorder", "select", context).forEach((select) => {
        select.addEventListener("change", () => updateSelectBorder(select));
      });
      once("webformSelectBorderSubmit", ".form-submit", context).forEach(
        (submit) => {
          submit.addEventListener("click", () => {
            document.querySelectorAll("select").forEach(updateSelectBorder);
          });
        },
      );

      // Cache les champs captcha, affiche une erreur si le recaptcha n'est
      // pas rempli à la soumission.
      once("webformCaptcha", ".form-item-captcha-validation", context).forEach(
        (captcha) => {
          captcha.querySelectorAll("label, span, input").forEach((el) => {
            el.style.display = "none";
          });
        },
      );

      once("webformCaptchaSubmit", "form", context).forEach((form) => {
        form.addEventListener("submit", (event) => {
          const captcha = form.querySelector(".form-item-captcha-validation");
          const recaptcha = new FormData(form).get("g-recaptcha-response");
          const feedback = captcha
            ? captcha.querySelector(".invalid-feedback")
            : null;

          if (recaptcha === "") {
            if (feedback) {
              feedback.style.display = "block";
            }
            event.preventDefault();
          } else if (feedback) {
            feedback.style.display = "none";
          }
        });
      });
    },
  };

  // Equivalent vanilla de jQuery .width() : largeur du contenu seul.
  function contentWidth(el) {
    const style = getComputedStyle(el);
    return (
      el.clientWidth -
      (parseFloat(style.paddingLeft) || 0) -
      (parseFloat(style.paddingRight) || 0)
    );
  }

  // Recalcule les marges de centrage du contenu (largeur max 1215px) :
  // appelée par ce fichier et par menu.js à chaque ouverture/fermeture de
  // menu, exposée globalement pour cette raison.
  window.checkResize = function checkResize() {
    if (window.matchMedia("(min-width: 992px)").matches) {
      const margin = (contentWidth(document.body) - 1215) / 2;

      document.querySelectorAll(".marge-en-couleur").forEach((el) => {
        if (margin > 0) {
          el.style.marginLeft = `-${margin}px`;
          el.style.paddingLeft = `${margin}px`;
        } else {
          el.style.marginLeft = "unset";
          el.style.paddingLeft = "unset";
        }
      });

      document.querySelectorAll(".couleur-blanc-menu").forEach((el) => {
        if (margin > 0) {
          el.style.marginRight = `-${margin}px`;
          el.style.paddingRight = `${margin}px`;
        } else {
          el.style.marginRight = "unset";
          el.style.paddingRight = "unset";
        }
      });
    } else {
      document.querySelectorAll(".couleur-blanc-menu").forEach((el) => {
        el.style.marginRight = "unset";
        el.style.paddingRight = "unset";
      });
    }
  };

  // Header du site : burger mobile, masquage/réapparition au scroll, et
  // "peek" au survol de la souris en haut de l'écran (desktop).
  Drupal.behaviors.siteHeader = {
    attach(context) {
      const lgHeaderHeight = 190;

      once("pageBurger", ".boutonMenuBurger", context).forEach((burger) => {
        burger.addEventListener("click", () => {
          document.body.classList.toggle(
            "menu-is-open",
            burger.getAttribute("aria-expanded") !== "true",
          );
        });
      });

      once("pageScroll", "body", context).forEach(() => {
        const navbar = document.getElementById("grtgazHeader");
        let prevScrollPos = window.pageYOffset;
        let openByScroll = true;

        window.addEventListener("scroll", () => {
          const currentScrollPos = window.pageYOffset;
          const menuIsOpen = document.body.classList.contains("menu-is-open");

          if (prevScrollPos > currentScrollPos) {
            navbar.style.top = "0";
            openByScroll = true;
          } else if (
            window.matchMedia("(min-width: 992px)").matches &&
            currentScrollPos > 95 &&
            !menuIsOpen
          ) {
            navbar.style.top = `-${lgHeaderHeight}px`;
          } else if (
            window.matchMedia("(max-width: 991px)").matches &&
            currentScrollPos > 70 &&
            !menuIsOpen
          ) {
            navbar.style.top = "-70px";
          }
          prevScrollPos = currentScrollPos;
        });

        window.addEventListener("resize", () => window.checkResize());

        const mainGrtGaz = document.getElementById("main-grtGaz");
        if (mainGrtGaz) {
          mainGrtGaz.addEventListener("mousemove", (event) => {
            if (!window.matchMedia("(min-width: 992px)").matches) {
              return;
            }
            const currentScrollPos = window.pageYOffset;
            if (event.clientY < 100) {
              navbar.style.top = "0";
              openByScroll = false;
            } else if (
              currentScrollPos > 95 &&
              !openByScroll &&
              !document.body.classList.contains("menu-is-open")
            ) {
              navbar.style.top = `-${lgHeaderHeight}px`;
            }
          });
        }
      });

      setTimeout(() => window.checkResize(), 400);
    },
  };

  // Accordéon FAQ (page "Questions/réponses").
  Drupal.behaviors.toggleReponses = {
    attach(context) {
      once("questionReponseToggle", ".js-toggle", context).forEach((btn) => {
        btn.addEventListener("click", () => {
          const customPlus = btn.querySelector(".custom-plus");
          if (customPlus) {
            customPlus.classList.toggle("custom-moins");
          }

          const faqReponse = btn.nextElementSibling;
          faqReponse.style.display =
            faqReponse.style.display === "block" ? "none" : "block";
        });
      });
    },
  };

  // Hauteur de l'aplat de couleur sur l'entête image-portrait, en fonction
  // de la hauteur des contenus de l'entête (page Témoignage).
  function computeAplatCouleurHeight() {
    if (window.screen.width <= 650) {
      return;
    }
    const entetePortraitTemoignage = document.querySelector(
      ".node--type-temoignage .en-tete-image-portrait",
    );
    if (!entetePortraitTemoignage) {
      return;
    }
    const title = document.querySelector(
      ".node--type-temoignage .en-tete-image-portrait .page-title-container",
    );
    const fonction = document.querySelector(
      ".node--type-temoignage .en-tete-image-portrait .fonction",
    );
    const accroche = document.querySelector(
      ".node--type-temoignage .en-tete-image-portrait .accroche-page",
    );
    const height =
      (title ? title.offsetHeight : 0) +
      (fonction ? fonction.offsetHeight : 0) +
      (accroche ? accroche.offsetHeight : 0);

    const aplatCouleur = document.querySelector(
      ".node--type-temoignage .en-tete-image-portrait .background-image-page",
    );
    if (aplatCouleur) {
      aplatCouleur.style.height = height <= 547 ? `${547 - height}px` : "0px";
    }

    const blockPartage = document.getElementById("block-partagerrsstemoignage");
    if (blockPartage) {
      blockPartage.style.transform =
        height > 547 ? `translateY(${height - 547}px)` : "translateY(0px)";
    }
  }

  // Accordion : épaisseur du séparateur du bas lorsque l'accordéon est ouvert.
  function toggleAccordionBorder(event) {
    const targetElement = event.target.closest(".lign-open-accordion");
    const card = targetElement.parentElement.closest(".card");
    const span = targetElement.querySelector(":scope > span");
    if (card) {
      card.classList.toggle(
        "borderBottom",
        !!(span && span.classList.contains("custom-plus")),
      );
    }
  }

  // Comportements généraux du thème : nettoyage des tirets par défaut des
  // <select>, alt vide sur les images sans attribut, repositionnement du
  // footer, placement du bloc de partage RRSS selon le type d'entête,
  // marges de listes, bordure de l'accordéon ouvert.
  Drupal.behaviors.global = {
    attach(context) {
      once("global", "body", context).forEach(() => {
        // Supprime les tirets par défaut des <select> (ex. "- Sélectionner -").
        function removeHyphens(element) {
          element.innerHTML = element.innerHTML.replace(/(^-|-$)/gm, "");
        }

        document.querySelectorAll("select").forEach((select) => {
          if (select.firstElementChild) {
            removeHyphens(select.firstElementChild);
          }
        });

        document.querySelectorAll("img:not([alt])").forEach((img) => {
          img.setAttribute("alt", "");
        });

        // Remet le footer au même niveau d'arborescence que main, surtout
        // dans la page d'accueil.
        const myMain = document.querySelector("main.contenu-principal");
        const myFooter = document.querySelector("footer");
        if (myMain && myFooter) {
          myMain.parentNode.insertBefore(myFooter, myMain.nextSibling);
        }

        // Affiche RRSS : si la case "Affiche RRSS" est cochée dans l'admin,
        // un span #affiche_rrss est ajouté dans le DOM (caché).
        const afficheRRSS = document.getElementById("affiche_rrss");
        const blockPartagerRRSS = document.getElementById("block-partagerrss");
        const afficheRRSSTemoignage = document.getElementById(
          "affiche_rrss_temoignage",
        );
        const blockPartagerRRSSTemoignage = document.getElementById(
          "block-partagerrsstemoignage",
        );
        const pageTemoignage = document.body.classList.contains(
          "page-node-type-temoignage",
        );

        // On affiche le bloc partage témoignage uniquement sur les pages témoignage.
        if (pageTemoignage) {
          if (blockPartagerRRSSTemoignage) {
            blockPartagerRRSSTemoignage.style.display = afficheRRSSTemoignage
              ? "block"
              : "none";
          }
        } else if (blockPartagerRRSS) {
          blockPartagerRRSS.style.display = afficheRRSS ? "block" : "none";
        }

        // Placement RRSS en fonction de l'entête image / image-portrait / vidéo.
        const enteteImage = document.querySelector(".en-tete-image");
        const entetePortrait = document.querySelector(
          ".en-tete-image-portrait",
        );
        const enteteVideo = document.querySelector(".en-tete-video");

        if (pageTemoignage) {
          if (enteteVideo && blockPartagerRRSSTemoignage) {
            const emplacementBloc =
              enteteVideo.querySelector(".partage-en-tete");
            if (emplacementBloc) {
              emplacementBloc.appendChild(blockPartagerRRSSTemoignage);
            }
          }
          if (entetePortrait && blockPartagerRRSSTemoignage) {
            const emplacementBloc =
              entetePortrait.querySelector(".image-en-tete");
            if (emplacementBloc) {
              emplacementBloc.parentNode.insertBefore(
                blockPartagerRRSSTemoignage,
                emplacementBloc,
              );
            }
          }
        } else if (blockPartagerRRSS) {
          if (enteteImage) {
            const emplacementBloc =
              enteteImage.querySelector(".partage-en-tete");
            if (emplacementBloc) {
              emplacementBloc.appendChild(blockPartagerRRSS);
            }
          } else if (enteteVideo) {
            const emplacementBloc =
              enteteVideo.querySelector(".partage-en-tete");
            if (emplacementBloc) {
              emplacementBloc.appendChild(blockPartagerRRSS);
            }
          } else if (entetePortrait) {
            const emplacementBloc =
              entetePortrait.querySelector(".image-en-tete");
            if (emplacementBloc) {
              emplacementBloc.parentNode.insertBefore(
                blockPartagerRRSS,
                emplacementBloc,
              );
            }
          }
        }

        // Séparation de 10px au lieu de 15px pour les paragraphes précédents une liste à puce.
        document
          .querySelectorAll(".format-texte-libre ul, .format-texte-libre ol")
          .forEach((list) => {
            const prev = list.previousElementSibling;
            if (prev && prev.tagName === "P") {
              prev.style.marginBottom = "0";
            }
          });

        document
          .querySelectorAll(".accordion .card .lign-open-accordion")
          .forEach((link) => {
            link.addEventListener("click", toggleAccordionBorder);
          });

        computeAplatCouleurHeight();
        window.addEventListener("resize", computeAplatCouleurHeight);
      });
    },
  };
})();
